import * as React from 'react';
import {connect} from 'react-redux';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as FleetModule from 'Modules/FleetModule';
import {
    CarPathComponent,
    Coordinates,
    DistanceElement,
    FleetBlock,
    VehicleSpeedIcons,
    VehicleSpeedImage
} from './_CompositesHelpers';
import {withTranslation} from 'react-i18next';
import moment from 'moment';
import {LanguagesDetails} from 'Models/Dictionary';
import {EnumTypes} from "Models/EnumTypes/PageEnumTypes";
import Languages = EnumTypes.Languages;
import FoldableElement from "components/Layout/FoldableElement/FoldableElement";
import {combineClasses} from "components/Layout/Search/Search.Component";

type Props = {
    title?: string;
    zone?: HistoryModule.EnumTypes.CarDetailsViewType;
};
type ConnectedProps = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    fleetStore: FleetModule.Types.FleetStore;
};
type DispatchedProps = {
    t?: Function;
    setCarName: Function;
    getCarImages: Function;
    getCarDetails: Function;
    getSingleCarDistanceWeek: Function;
    getSingleCarDistanceMonth: Function;
};
type S = {
    saveNotesChanges: boolean;
    carName: string;
    carImageSource: any;
    carImageVisible: boolean;
    noCarPhotosAvailable: boolean;
};

class Car extends React.Component<Props & ConnectedProps & DispatchedProps, S> {
    private timeoutId: any;

    constructor(props: Props & ConnectedProps & DispatchedProps) {
        super(props);
        this.state = {
            saveNotesChanges: false,
            carName: '',
            carImageSource: null,
            carImageVisible: false,
            noCarPhotosAvailable: false
        };
        this.init = this.init.bind(this);
    }

    public componentDidMount() {
        const {activeVehicleDetails} = this.props.vehiclesStore;
        if (activeVehicleDetails) {
            this.setState({
                carName: activeVehicleDetails.name || ''
            });
        }
    }

    public shouldComponentUpdate(nextProps: Props & ConnectedProps & DispatchedProps) {
        if (nextProps.vehiclesStore.activeVehicleDetails) {
            if (!this.props.vehiclesStore.activeVehicleDetails) {
                this.setState({
                    carName: nextProps.vehiclesStore.activeVehicleDetails.name || ''
                });
            } else if (this.props.vehiclesStore.activeVehicleDetails.id !== nextProps.vehiclesStore.activeVehicleDetails.id) {
                this.setState({
                    carName: nextProps.vehiclesStore.activeVehicleDetails.name || '',
                    carImageVisible: false,
                    carImageSource: null,
                    noCarPhotosAvailable: false
                });
                this.init(nextProps);
            }
        }
        return true;
    }

    public async init(nextProps: Props & ConnectedProps & DispatchedProps) {
        this.setState({
            carName: nextProps.vehiclesStore.activeVehicleDetails.name || ''
        });
    }

    private updateName(carName: string) {
        const {activeVehicleDetails} = this.props.vehiclesStore;
        if (carName !== activeVehicleDetails.name) {
            this.setState({
                saveNotesChanges: true,
                carName
            });
            try {
                const doneTyping = async () => {
                    await this.props.setCarName(carName, activeVehicleDetails.id);
                    this.setState({
                        saveNotesChanges: false
                    });
                };
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(doneTyping, 1000);
            } catch (err) {
                //
            }
        }
    }

    private async showCarImage() {
        const {
            vehiclesStore: {activeVehicleDetails},
            getCarImages
        } = this.props;

        this.setState({
            carImageVisible: true,
            noCarPhotosAvailable: false,
            carImageSource: null
        });

        await getCarImages(activeVehicleDetails.id);
        const {vehiclesStore: {choosenCarImages}} = this.props;

        if (Object.entries(choosenCarImages).length && choosenCarImages.constructor === Object) {
            const file = {guid: choosenCarImages.guid, mimeType: choosenCarImages.mimeType};
            const singleImageResponse = await VehiclesModule.Connector.getFileBase(file);
            const reader = new FileReader();
            reader.readAsDataURL(singleImageResponse.response);
            reader.onload = () => {
                this.setState({
                    carImageSource: reader.result as string
                });
            };
        } else {
            this.setState({
                noCarPhotosAvailable: true
            });
        }
    }

    private getCountryFlag(_countryCode) {
        const countryCode: Languages = _countryCode;
        try {
            return <img src={LanguagesDetails.get(Languages[countryCode]).iconSrc} width="20" className="mr-10"/>;
        } catch (e) {
            return <img src='/images/icons/direction_arrow.svg' width="20" className="mr-10"/>
        }
    }

    public render() {
        const {vehiclesStore: {singleCarViewData}, t} = this.props;
        if (singleCarViewData) {
            const {
                car,
                distanceCurrentWeekKilometers,
                distanceLastWeekKilometers,
                distanceCurrentMonthKilometers,
                distanceLastMonthKilometers,
                onTourSince,
                lastParked
            } = singleCarViewData;


          const shouldLinkBeDisabled = !car.latestDataframe
            || typeof car.latestDataframe?.latitude !== 'number'
            || typeof car.latestDataframe?.longitude !== 'number'

            return (
                <div className="car-details">
                    {car.latestDataframe && (
                        <div className="car-details__speed-info">
                            <VehicleSpeedIcons
                                allowedSpeed={car.latestDataframe.speedLimitKmh}
                                currentSpeed={car.latestDataframe.speedGps}
                                turnedOn={car.latestDataframe.turnedOn}
                                speedLimitExceedance={car.latestDataframe.speedLimitExceedance}
                            />
                            <VehicleSpeedImage
                                carCategory={car.carCategory}
                                turnedOn={car.latestDataframe.turnedOn}
                                speedLimitExceedance={car.latestDataframe.speedLimitExceedance}
                            />
                        </div>
                    )}
                    <div className="scrollable">
                        {car.latestDataframe && (
                            <div className="car-details__element car-details__element--no-padding">
                                <div className="car-details__icons car-details__icons--justify-space">
                                    <div className="car-details__single-icon">
                                        <i className="icon icon--sat__blue"/>
                                        <span>{car.latestDataframe.satellite}</span>
                                    </div>
                                    <div className="car-details__single-icon">
                                        <i className="icon icon--voltage__blue"/>
                                        <span>{car.latestDataframe.mainPowerSupplyVoltage}V</span>
                                    </div>
                                    <div className="car-details__single-icon">
                                        <i className="icon icon--connection__blue"/>
                                        <span>{Math.round(car.latestDataframe.gsmSignal)}%</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="car-details__element flex flex--center">
                            <div className="car-details__half">
                                <div className="form-field form-field--clear-margin">
                                    <input
                                        className="form-field__input"
                                        type="text"
                                        placeholder={t('carNameNew')}
                                        value={this.state.carName}
                                        onChange={e => {
                                            this.updateName(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="car-details__half car-details__half--right flex--space-between">
                                <div className="carDetailsComposite__plate">{car.licensePlate}</div>
                                <div className="btn btn--clean carDetailsComposite__button--center">
                                    <img src="/images/icons/add_image.svg" width="15" alt=""
                                         onClick={() => this.showCarImage()}/>
                                </div>
                            </div>
                        </div>

                        <div className="car-details__element">
                            {this.state.carImageVisible && (
                                <div className="carDetailsComposite__image-popup">
                                    {!this.state.noCarPhotosAvailable ? (
                                        <>{this.state.carImageSource ?
                                            <img src={this.state.carImageSource} className="responsive"/> :
                                            <div className="loader__inner loader__inner--sm"/>}</>
                                    ) : (
                                        <h4 className="bold text-center">{t('noImageAvailable')}</h4>
                                    )}
                                    <div className="icon--exit"
                                         onClick={() => this.setState({carImageVisible: false})}/>
                                </div>
                            )}
                        </div>

                        <div className="car-details__element car-details__element--no-padding">
                            <FleetBlock fleets={car.fleets}/>
                        </div>
                        <div className="car-details__element">
                            <h4 className="heading--light">{t('carId')}</h4>
                            <h4 className="heading">
                                {car.vin} [{car.deviceId}]
                            </h4>
                        </div>
                        {car.latestDataframe && (
                            <><div
                                className="car-details__element">
                                {car.latestDataframe.address && (
                                    <div className="car-details__address">
                                        {this.getCountryFlag(car.latestDataframe.address.countryCode)}
                                        <span className="font-blue">
                                            {car.latestDataframe.address.addressDisplayName}
                                        </span>
                                    </div>
                                )}
                                {car.latestDataframe && 
                                <Coordinates lat={car.latestDataframe.latitude} lng={car.latestDataframe.longitude}/>}
                            </div>
                            <div className="car-details__element" style={{display: 'flex', gap: '16px'}}>
                                <h4 className="heading--light">Ostatnia aktywność:</h4>
                                <div className="">{moment(car?.latestDataframe?.dateTime).format('DD-MM-YYYY HH:mm:ss') ?? 'b.d.'}</div>
                            </div>
                            </>
                        )}
                        {(car.latestDataframe && lastParked) &&
                        <CarPathComponent
                            carCategory={car.carCategory}
                            mileageGps={car.latestDataframe.mileageGps}
                            speedGps={car.latestDataframe.speedGps}
                            turnedOn={car.latestDataframe.turnedOn}
                            speedLimitKmh={car.latestDataframe.speedLimitKmh}
                            durationSeconds={lastParked.durationSeconds}
                            endDate={lastParked.endDate}
                            startDate={lastParked.startDate}
                            t={t}
                            onTourSince={onTourSince}/>
                        }

                      <div className={combineClasses('car-details__link', shouldLinkBeDisabled && 'car-details__link--disabled')}>
                        <a
                          className="details-right__dashboard-item--link"
                          href={`https://www.google.com/maps/search/?api=1&query=${car.latestDataframe?.latitude},${car.latestDataframe?.longitude}`}
                          target="_blank"
                          // @ts-ignore
                          disabled={shouldLinkBeDisabled}
                          aria-disabled={shouldLinkBeDisabled}
                        >
                          <span>{t('SHOW_IN_GOOGLE_MAPS')}</span>
                          <span>
                            <img
                              src={`/images/icons/google-maps.svg`}
                              alt=""/>
                          </span>
                        </a>
                      </div>
                      <div className="car-details__element">
                        <FoldableElement title={t('distanceWeek')} labelId='element-distance-week'
                                         onClickFunction={() => this.props.getSingleCarDistanceWeek(car?.id)}
                                         elementId={car?.id}>
                          <DistanceElement
                            title={t('distanceCurrent')}
                            distance={distanceCurrentWeekKilometers}
                            dateFrom={moment()
                                        .subtract(7, 'days')
                                        .format('DD-MM-YYYY')}
                                    dateTo={moment().format('DD-MM-YYYY')}
                                />
                                <DistanceElement
                                    title={t('distancePrevious')}
                                    distance={distanceLastWeekKilometers}
                                    dateFrom={moment()
                                        .subtract(14, 'days')
                                        .format('DD-MM-YYYY')}
                                    dateTo={moment().subtract(7, 'days').format('DD-MM-YYYY')}
                                    rightHalf
                                />
                            </FoldableElement>
                        </div>
                        <div className="car-details__element">
                            <FoldableElement title={t('distanceMonth')} labelId='element-distance-month'
                                             onClickFunction={() => this.props.getSingleCarDistanceMonth(car?.id)}
                                             elementId={car?.id}>
                                <DistanceElement
                                    title={t('distanceCurrent')}
                                    distance={distanceCurrentMonthKilometers}
                                    dateFrom={moment()
                                        .subtract(1, 'month')
                                        .format('DD-MM-YYYY')}
                                    dateTo={moment().format('DD-MM-YYYY')}
                                />
                                <DistanceElement
                                    title={t('distancePrevious')}
                                    distance={distanceLastMonthKilometers}
                                    dateFrom={moment()
                                        .subtract(2, 'month')
                                        .format('DD-MM-YYYY')}
                                    dateTo={moment().subtract(1, 'month').format('DD-MM-YYYY')}
                                    rightHalf
                                />
                            </FoldableElement>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="car-details__no-details">
                    <h4 className="heading">{t('noDataTitle')}</h4>
                    <p>{t('noDataDescription')}</p>
                </div>
            );
        }
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        vehiclesStore: state.vehiclesStore,
        fleetStore: state.fleetStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        setCarName: (carName: string, carId: number) => dispatch(VehiclesModule.Actions.setCarName(carName, carId)),
        getCarImages: (carId: number) => dispatch(VehiclesModule.Actions.getCarImages(carId)),
        getCarDetails: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId)),
        getSingleCarDistanceWeek: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDistanceWeek(carId)),
        getSingleCarDistanceMonth: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDistanceMonth(carId))
    };
}

export default withTranslation('carDetails')(
    connect<{}, {}, Props>(
        mapStateToProps,
        mapDispachToProps
    )(Car) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Composites/Car.tsx